import { render } from "./ErrorContent.vue?vue&type=template&id=e639d214"
import script from "./ErrorContent.vue?vue&type=script&lang=js"
export * from "./ErrorContent.vue?vue&type=script&lang=js"

import "./ErrorContent.vue?vue&type=style&index=0&id=e639d214&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__